export enum BroadcastMessageDialogFormNames {
  MESSAGE = 'message',
  EXPIRY_DATE = 'expiryDate',
  EFFECTIVE_DATE = 'effectiveDate'
}
